import ApiBase from "./apiBase";

const routeScheduleChangesApi = new ApiBase("/routes/route-schedule-changes");

export default routeScheduleChangesApi;
